const apiStatus = (error) => Number(error?.response?.status || error?.tavernReport?.status || 0);

export const isGoneOrConflict = (error) => [404, 409].includes(apiStatus(error));

export const nightInvitationResponseMessage = (error, t) =>
  isGoneOrConflict(error)
    ? t('nights.feedback.invitationNoLongerAvailable')
    : t('nights.feedback.invitationResponseError');

export const companionRequestResponseMessage = (error, t) =>
  isGoneOrConflict(error)
    ? t('friends.requests.noLongerAvailable')
    : t('friends.requests.respondError');

export const companionRequestCancelMessage = (error, t) =>
  isGoneOrConflict(error)
    ? t('friends.requests.cancelNoLongerPending')
    : t('friends.requests.cancelError');
